import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "./scroll";

export const useAnchorNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return (e, id) => {
    e.preventDefault();
    if (location.pathname === "/") {
      scrollToId(id);
    } else {
      navigate({ pathname: "/", hash: `#${id}` });
    }
  };
};
